import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { FormGroup } from "reactstrap";
import { Input } from "../../../../shared/Input/Input";
import { CustomerSettingsVariables } from "../../InsightsCard/Insights/Insights";
import { OrganizationSettingsModal } from "../../shared/OrganizationSettingsModal";
import { AdminNotificationsSetting } from "./AdminNotificationsSetting";
import { InputDescription } from "../../../../shared/InputDescription/InputDescription";

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  email?: string;
  systemNotificationRecipientUserIds?: string[];
  handleEmailNotifications: ({
    errorReportingEmail,
    systemNotificationRecipientUserIds,
  }: CustomerSettingsVariables) => void;
  loading: boolean;
  error?: Error;
}

export const ServiceEmailModal = ({
  isOpen,
  setIsOpen,
  email,
  systemNotificationRecipientUserIds,
  handleEmailNotifications,
  error,
  loading,
}: Props) => {
  const [emailToChange, setEmailToChange] = useState(email || "");
  const [selectedAdminIds, setSelectedAdminIds] = useState<string[]>(
    systemNotificationRecipientUserIds || []
  );

  useEffect(() => {
    setEmailToChange(email || "");
  }, [email]);

  useEffect(() => {
    setSelectedAdminIds(systemNotificationRecipientUserIds || []);
  }, [systemNotificationRecipientUserIds]);

  return (
    <OrganizationSettingsModal
      title="Email notifications"
      formTitle="Settings for system email notifications."
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      loading={loading}
      error={error}
      formClassName="d-block"
      modalClassName="Bookings"
      disabled={!/\S+@\S+\.\S+/.test(emailToChange)}
      toggleModal={() => {
        setEmailToChange(email || "");
        setSelectedAdminIds(systemNotificationRecipientUserIds || []);
        setIsOpen(false);
        return;
      }}
      handleSave={() => {
        handleEmailNotifications({
          errorReportingEmail: emailToChange,
          systemNotificationRecipientUserIds: selectedAdminIds,
        });
        setIsOpen(false);
        return;
      }}
    >
      <AdminNotificationsSetting
        selectedAdminIds={selectedAdminIds}
        onChange={setSelectedAdminIds}
      />

      <FormGroup className="w-100 mb-0">
        <label className="label__main">Room equipment error reports</label>

        <Input
          type="email"
          name="errorReportingEmail"
          id="errorReportingEmail"
          value={emailToChange}
          invalid={!/\S+@\S+\.\S+/.test(emailToChange)}
          onChange={(e) => setEmailToChange(e.target.value)}
        />

        <InputDescription
          description="Default email address for error reports sent from all meeting room displays."
          className="pt-2"
        />
      </FormGroup>
    </OrganizationSettingsModal>
  );
};
